import { useQuery } from '@hooks/reactQuery';

import { getDefaultGNodeBConfigParameters } from '@api/gNodeBConfigParameters';

import {
	IDefaultGNodeBConfigParameter,
	IDefaultGNodeBConfigParameters,
	IGNodeBConfigParametersValidationRule,
} from '@interfaces/crowdcell/gNodeBConfig';

import {
	GET_DEFAULT_GNODEB_CONFIG_PARAMETERS,
} from '@constants/queryKeys';

export interface IUseDefaultConfigParametersReturnedType {
	defaultConfigParameters?: IDefaultGNodeBConfigParameters;
	isLoading: boolean;
	validationRules?: IGNodeBConfigParametersValidationRule[];
}

export function useDefaultConfigParameters(): IUseDefaultConfigParametersReturnedType {
	const {
		data: defaultConfigParameters,
		isLoading,
		isFetching,
	} = useQuery<IDefaultGNodeBConfigParameters>({
		queryKey: [GET_DEFAULT_GNODEB_CONFIG_PARAMETERS],
		queryFn: () => getDefaultGNodeBConfigParameters(),
		refetchOnWindowFocus: false,
	});

	return {
		defaultConfigParameters: defaultConfigParameters,
		isLoading: isLoading || isFetching,
		validationRules: defaultConfigParameters?.parameters?.map((parameter: IDefaultGNodeBConfigParameter) => {
			return {
				parameterName: parameter.name,
				validationList: parameter.validationList?.map(item => Number(item)),
				validationInt: {
					from: parameter.validationIntFrom,
					to: parameter.validationIntTo,
				},
				validationType: parameter.validationType,
				isCondition: parameter.isCondition,
			};
		}),
	};
}
